import router from './router'

import IndexMessages from './localization'

export default {
  router,
  localization: IndexMessages,
}
